import { Component, Input, OnInit } from '@angular/core';


@Component({
  selector: 'kendo-grid-cell-icon',
  template: `
    <span class="k-icon {{icon}}"></span> {{text}}`,
  // styles: [`
  //   kendo-progressbar {
  //     width: 100%;
  //   }`],
})
export class KendoGridCellIconComponent implements OnInit {

  @Input() icon: string = '';
  @Input() text: string = '';

  constructor() { }
 
  ngOnInit() { }

}
